<template>
  <div class="welcome container align-left">
    <section class="section has-padding-top-0">
      <div class="container">
        <div class="columns">
          <div class="column texts is-half">
            <h1 class="title is-1">{{ $t("views.landing.title") }}</h1>

            <div v-html="$t('views.landing.text')"></div>

            <b-button type="is-primary" size="is-large" expanded @click="login">
              {{ $t("views.landing.signup") }}
            </b-button>
          </div>
          <div class="column image is-half">
            <img src="../assets/photo/white-cropped.jpg" alt="" />
          </div>
        </div>

        <hr />
      </div>
    </section>
  </div>
</template>

<script>
import { AuthClient, authClient } from "@/auth0";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Welcome extends Vue {
  // Log the user in
  async login() {
    await authClient.login();
  }

  mounted() {
    this.$store.commit("stopLoading");
  }
}
</script>

<style scoped lang="scss">
.welcome {
  .column {
    &.texts {
      padding-top: 64px;

      p {
        font-size: 1.2em;
        padding-top: 12px;
      }
      h1 {
        font-size: 3em;
      }
      button {
        margin-top: 36px;
      }
    }
  }
}
</style>
